// extracted by mini-css-extract-plugin
export default {"categories":"IQ8Wfyc1STdBCw5_o1uo","category":"OmKMfTfacMV8g4eV52GE"};